// @flow
import { useCallback, useState, useEffect } from 'react'
import merge from 'ramda/es/merge'
import { useTranslation } from 'react-i18next'

import { api, appTypes } from 'app/api'
import {
  GET_SUPPORT_INFO,
  convertResult,
  defaultState,
} from 'app/common/api/requests/cabinet/support'
import { SupportType } from 'app/dataTypes/cabinet/support/SupportTypes'

export default function useHelpInfoData() {
  const { t } = useTranslation('help')

  const [supportData, setSupportData] = useState<SupportType>(defaultState)
  const [loading, setLoading] = useState(true)

  const handleRequestData = useCallback(async () => {
    if ((process.env.APP_NAME || process.env.REACT_APP_NAME) !== appTypes.APP_TYPE_CABINET)
      return false
    setLoading(true)
    const supportRes = await api.request(GET_SUPPORT_INFO, {
      error: t('error_get_help_info_fail', 'Не удалось получить иформацию по поддержке') as string,
      convertions: {
        convertResult,
      },
    })
    setLoading(false)

    if (supportRes) {
      setSupportData(merge(defaultState, supportRes))
      return true
    }

    return false
  }, [t])

  useEffect(() => {
    handleRequestData()
  }, [handleRequestData])

  return { supportData, loading }
}
